// Third-party
import React from 'react';
import classNames from 'classnames';
import camelCase from 'lodash/camelCase';

// Components
import { CardButton } from '../../../../../views/components/buttons';
import { Typography } from '@capintel/component-lib/typography';

// Utils
import { FormattedMessage, formatMessage } from '../../../../../utils/i18n';
import { PROPOSAL_ORIENTATION } from '../../../utils/constants';
import ProposalOrientation from '@/types/proposal-orientation';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  selectedOrientation: string;
  onOrientationChange: (orientation: ProposalOrientation) => void;
};

const ProposalOrientationSelector: React.FunctionComponent<Props> = ({ selectedOrientation, onOrientationChange }: Props) => {
  const orientations = Object.values(PROPOSAL_ORIENTATION);

  return (
    <div className="proposal-orientation-selector proposal-option">
      <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
        <FormattedMessage id="Proposal.Tabs.Options.Orientation" />
      </Typography>

      <div className="proposal-orientation-toggle d-flex">
        {orientations.map(orientation => {
          const classes = classNames('proposal-orientation-option', {
            selected: selectedOrientation === orientation,
          });

          const label = formatMessage(`Proposal.Tabs.Options.Orientations.${orientation}`);
          const labelId = `orientation-label-${camelCase(orientation)}`;
          return (
            <div key={orientation} className={classes}>
              <div>
                <CardButton onClick={() => onOrientationChange(orientation)} aria-labelledby={labelId} />
                <div className={orientation.toLowerCase()} />
              </div>

              <span id={labelId}>{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProposalOrientationSelector;
